import { matchPath, useLocation } from 'react-router-dom'
import { Roles } from '../models'
import { RouteNames } from 'models/routes'
import { useAppSelector } from './store'

const scopes = {
  user: [],
  admin: [RouteNames.llistatOrgans, RouteNames.novaPlantilla, RouteNames.llistatPlantilles],
  common: [
    RouteNames.errorPage,
    RouteNames.copiaCallback,
    RouteNames.novaCopia,
    RouteNames.home,
    RouteNames.sessioCopia
  ]
}

export default function useScopes() {
  const location = useLocation()
  const role = useAppSelector((state) => state.ens.rol)
  const isRoute = Object.values(RouteNames).some(
    (pattern) => matchPath(pattern, location.pathname) !== null
  )

  return {
    hasPermission: () => {
      switch (role) {
        case Roles.user:
          return isRoute
            ? scopes.common.some((pattern) => {
                return matchPath(pattern, location.pathname) !== null
              })
            : true
        case Roles.admin:
          return true
        default:
          return !isRoute
      }
    }
  }
}
